import { Identified } from '@optimus-web/core';

export interface MatrixMainMapping<T> extends Partial<Identified> {
    title: React.ReactNode;
    valueKey: keyof T;
    headerAlignment?: ColumnAlignment;
    columnAlignment?: ColumnAlignment;
}

export enum ColumnAlignment {
    Center = 'center',
    Left = 'left',
    Right = 'right',
}

export enum SortOrder {
    Ascending = 'asc',
    Descending = 'desc',
}

export type MatrixTextVariant = 'disabled' | 'secondary';

export interface MatrixCellColor {
    color: 'primary' | 'success' | 'info' | 'danger' | 'warning' | 'basic' | 'successLight';
    intensity?: number;
}
export interface Bordered {
    bordered?: boolean;
}

export interface Emphasized {
    emphasized?: boolean;
}

export interface Highlighted {
    highlighted?: boolean;
}
export interface Colored {
    cellColor?: MatrixCellColor;
}

export interface Hovered {
    hovered?: boolean;
}

export interface Selected {
    selected?: boolean;
}
